import { ArrowUpRight } from "lucide-react";

export function ProcessSection({ t }) {
    return (
        <section id="processus" className="section process-section" data-testid="reset365-process-section">
            <div className="page-width">
                <div className="section-heading reveal">
                    <p className="eyebrow" data-testid="reset365-process-eyebrow">{t.eyebrow}</p>
                    <h2 data-testid="reset365-process-title">{t.title}</h2>
                </div>
                <div className="process-grid">
                    {t.steps.map((step) => (
                        <article className="process-step reveal" key={step.number} data-testid={`reset365-process-step-${step.number}`}>
                            <span className="process-step__number">{step.number}</span>
                            <div><h3>{step.title}</h3><p>{step.text}</p></div>
                        </article>
                    ))}
                </div>
                <a href="#soumission" className="button button--primary process-cta" data-testid="reset365-process-quote-btn">
                    {t.cta}<ArrowUpRight size={16} aria-hidden="true" />
                </a>
            </div>
        </section>
    );
}
